import $ from 'jquery';

export const init = ($target) => {
	$target.on('click', '.js-scroll', function (e) {
		e.preventDefault();
		const scrollTarget = $($(this).attr('href'));
		if (scrollTarget.hasClass('u-js-hide')) {
			scrollTarget.removeClass('u-js-hide');
		}

		scrollToId($(this).attr('href'));

		if (scrollTarget.hasClass('accordion__item')) {
			const el = scrollTarget.find('.js-accordion');
			if (!el.hasClass('is-open')) {
				el.trigger('click');
			}
		}
	});
};

export function scrollToId(id) {
	const $id = $(id);
	if (!$id.length) {
		return;
	}
	$('body, html').animate(
		{
			scrollTop: $(id).offset().top - 32, // - $('.header').outerHeight()
		},
		500,
	);
}
